import { Select } from '@material/mwc-select';
import { css } from 'lit';
import { customElement } from 'lit/decorators';
import { isDefined } from '../../helpers/utils';

@customElement('proxi-selectfield-inline')
export class ProxiSelectfieldInline extends Select {
    static get styles() {
        return [
            ...Select.styles,
            css`
                :host {
                    --mdc-menu-item-height: 1rem;
                }

                .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above {
                    transform: translateY(-30.25px)translateX(-32px) scale(1);
                }

                .mdc-select--outlined .mdc-select--filled .mdc-select__anchor {
                    height: 1rem !important;
                }

                .custom-select-anchor {
                    height: 1rem !important;
                    width: unset !important;
                }

                .mdc-select__selected-text {
                    font-size: 0.8rem;
                }

                .mdc-select__dropdown-icon {
                    margin: 0;
                }

            `
        ];
    }

    async firstUpdated() {
        await super.firstUpdated();

        const selectAnchor = this.shadowRoot?.querySelector('.mdc-select__anchor') as HTMLElement;
        if (isDefined(selectAnchor)) {
            selectAnchor.classList.add('custom-select-anchor');
        }
    }
}
